const FSA_GROUP_PROPERTY = "_FSA Group";
const FSA_BUNDLE_PROPERTY = "_FSA Bundle";
const FSA_LABOR_PROPERTY = "_FSA Labor";
const FSA_HIDDEN_TOP_HAT_PROPERTY = "_FSA Hidden Top Hat";
const ADDON_SIGNATURE_PROPERTY = "_Addon Signature";
let reconciliationPromise = null;
const noticeTimers = /* @__PURE__ */ new WeakMap();
function propertyValue(item, name) {
  var _a;
  const value = (_a = item == null ? void 0 : item.properties) == null ? void 0 : _a[name];
  return value == null ? "" : String(value).trim();
}
function hasPropertyValue(item, name) {
  return Boolean(propertyValue(item, name));
}
function getLinkedFsaGroups(item) {
  const signature = propertyValue(item, ADDON_SIGNATURE_PROPERTY);
  const fsaPart = signature.split("|").find((part) => part.trim().startsWith("fsa="));
  if (!fsaPart)
    return [];
  return fsaPart.trim().slice(4).split(",").map((entry) => {
    const separator = entry.lastIndexOf(":");
    return separator === -1 ? "" : entry.slice(separator + 1).trim();
  }).filter(Boolean);
}
function getAssemblyDependencyUpdates(cart) {
  const items = Array.isArray(cart == null ? void 0 : cart.items) ? cart.items : [];
  const availableParentQuantity = /* @__PURE__ */ new Map();
  items.forEach((item) => {
    const quantity = Math.max(0, Number(item == null ? void 0 : item.quantity) || 0);
    if (!quantity)
      return;
    getLinkedFsaGroups(item).forEach((group) => {
      availableParentQuantity.set(
        group,
        (availableParentQuantity.get(group) || 0) + quantity
      );
    });
  });
  const laborGroups = new Set(
    items.filter((item) => hasPropertyValue(item, FSA_LABOR_PROPERTY)).map((item) => propertyValue(item, FSA_GROUP_PROPERTY)).filter(Boolean)
  );
  const updates = {};
  const affectedKeys = [];
  const assemblyKeys = [];
  items.forEach((item) => {
    const key = item == null ? void 0 : item.key;
    const quantity = Math.max(0, Number(item == null ? void 0 : item.quantity) || 0);
    if (!key || !quantity)
      return;
    const group = propertyValue(item, FSA_GROUP_PROPERTY);
    if (hasPropertyValue(item, FSA_BUNDLE_PROPERTY) && group) {
      const available = Math.max(0, availableParentQuantity.get(group) || 0);
      const nextQuantity = Math.min(quantity, available);
      availableParentQuantity.set(group, Math.max(0, available - nextQuantity));
      if (nextQuantity !== quantity) {
        updates[key] = nextQuantity;
        affectedKeys.push(key);
        assemblyKeys.push(key);
      }
      return;
    }
    if (hasPropertyValue(item, FSA_HIDDEN_TOP_HAT_PROPERTY) && group && !laborGroups.has(group)) {
      updates[key] = 0;
      affectedKeys.push(key);
    }
  });
  return { updates, affectedKeys, assemblyKeys };
}
async function getCart() {
  const response = await fetch("/cart.js", {
    headers: { Accept: "application/json" }
  });
  if (!response.ok)
    throw new Error(`Cart fetch failed (${response.status})`);
  return response.json();
}
function reconcileAssemblyDependencies(cart = null, sectionPayload = {}) {
  if (reconciliationPromise)
    return reconciliationPromise;
  reconciliationPromise = (async () => {
    var _a;
    const currentCart = Array.isArray(cart == null ? void 0 : cart.items) ? cart : await getCart();
    const { updates, affectedKeys, assemblyKeys } = getAssemblyDependencyUpdates(currentCart);
    if (!affectedKeys.length)
      return {
        cart: currentCart,
        changed: false,
        affectedKeys: [],
        noticeRequired: false
      };
    const response = await fetch(((_a = window.routes) == null ? void 0 : _a.cart_update_url) || "/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ updates, ...sectionPayload })
    });
    if (!response.ok)
      throw new Error(`Assembly dependency cleanup failed (${response.status})`);
    return {
      cart: await response.json(),
      changed: true,
      affectedKeys,
      noticeRequired: assemblyKeys.length > 0
    };
  })().finally(() => {
    reconciliationPromise = null;
  });
  return reconciliationPromise;
}
function showAssemblyRemovalNotice(root) {
  var _a;
  if (!(root instanceof Element))
    return;
  (_a = root.querySelector("[data-assembly-removal-notice]")) == null ? void 0 : _a.remove();
  const notice = document.createElement("div");
  notice.dataset.assemblyRemovalNotice = "true";
  notice.className = "mx-4 my-2 flex items-start justify-between gap-3 rounded-[6px] border border-[#d5d9e1] bg-[#f7f8fa] px-3 py-2 font-inter text-[12px] leading-[1.4] text-[#4e5663]";
  notice.setAttribute("role", "status");
  notice.setAttribute("aria-live", "polite");
  const message = document.createElement("span");
  message.textContent = "Assembly service was removed because it was tied to the lift kit.";
  const dismiss = document.createElement("button");
  dismiss.type = "button";
  dismiss.className = "shrink-0 cursor-pointer border-0 bg-transparent p-0 text-[16px] leading-none text-[#737373] hover:text-black";
  dismiss.setAttribute("aria-label", "Dismiss notice");
  dismiss.textContent = "×";
  dismiss.addEventListener("click", () => notice.remove(), { once: true });
  notice.append(message, dismiss);
  if (root.matches("cart-drawer")) {
    const header = root.querySelector("#CartDrawer header");
    header == null ? void 0 : header.insertAdjacentElement("afterend", notice);
  } else {
    const form = root.querySelector('form[action*="/cart"]');
    form == null ? void 0 : form.prepend(notice);
  }
  if (!notice.isConnected)
    return;
  const currentTimer = noticeTimers.get(root);
  if (currentTimer)
    window.clearTimeout(currentTimer);
  noticeTimers.set(root, window.setTimeout(() => {
    notice.remove();
    noticeTimers.delete(root);
  }, 7e3));
}
export {
  reconcileAssemblyDependencies,
  showAssemblyRemovalNotice
};
